import { gql, useQuery } from "@apollo/client";
import { Dayjs } from "dayjs";
import { AvailableTeacherSlotDto } from "./types.ts";

export const GetAvailableTeacherSlotsQuery = gql`
  query getAvailableTeacherSlots($fromDate: String!, $toDate: String!) {
    getAvailableTeacherSlots(fromDate: $fromDate, toDate: $toDate) {
      startUtc
      endUtc
      slotTimezone
      teacherIds
    }
  }
`;

export type GetAvailableTeacherSlotsQueryResult = {
  getAvailableTeacherSlots: AvailableTeacherSlotDto[];
};

export function useAvailableTeacherSlots({
  fromDate,
  toDate,
}: {
  fromDate: Dayjs;
  toDate: Dayjs;
}) {
  const { data, loading } = useQuery<GetAvailableTeacherSlotsQueryResult>(
    GetAvailableTeacherSlotsQuery,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
      },
    },
  );

  return {
    availableSlots: data?.getAvailableTeacherSlots ?? [],
    loading,
  };
}
